import React, { useState } from "react";
import { FaBars, FaTimes, FaHome, FaInfoCircle, FaProjectDiagram, FaCode, FaEnvelope } from 'react-icons/fa';
import Logo from '../images/personal-logo.png';

function NavBar({setActiveSection}) {
  const [navOpen, setNavOpen] = useState(false);

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  return (
    <nav className="fixed top-0 left-0 w-full p-4 flex justify-between items-center bg-transparent backdrop-filter backdrop-blur-md">
      <div className="flex items-center">
        <img src={Logo} alt="Logo" className="w-8 h-8 rounded-full" />
        <div className="md:hidden ml-2">
          {navOpen ? (
            <FaTimes onClick={toggleNav} className="text-white text-2xl cursor-pointer" />
          ) : (
            <FaBars onClick={toggleNav} className="text-white text-2xl cursor-pointer" />
          )}
        </div>
      </div>
      <ul className={`md:flex space-x-6 ${navOpen ? 'block' : 'hidden'} md:space-x-6 md:block mt-4 md:mt-0 `}>
      <li className="text-white hover:underline cursor-pointer md:text-right">
          <button
            onClick={() => setActiveSection("home")}
            className="inline-block text-xl mr-1 transition duration-300 transform hover:animate-runningColors hover:animate-runningColors"
            style={{ color: 'lightBlue' }}
          >
            <FaHome />
            Home
          </button>
        </li>
        <li className="text-white hover:underline cursor-pointer md:text-right">
          <button
            onClick={() => setActiveSection("about")}
            className="inline-block text-xl mr-1 transition duration-300 transform hover:animate-runningColors hover:animate-runningColors"
            style={{ color: 'Red' }}
          >
            <FaInfoCircle />
            About
          </button>
        </li><li className="text-white hover:underline cursor-pointer md:text-right">
          <button
            onClick={() => setActiveSection("projects")}
            className="inline-block text-xl mr-1 transition duration-300 transform hover:animate-runningColors hover:animate-runningColors"
            style={{ color: 'lightGreen' }}
          >
            <FaProjectDiagram />
            Projects
          </button>
        </li>
        <li className="text-white hover:underline cursor-pointer md:text-right">
          <button
            onClick={() => setActiveSection("skills")}
            className="inline-block text-xl mr-1 transition duration-300 transform hover:animate-runningColors hover:animate-runningColors"
            style={{ color: 'blue' }}
          >
            <FaCode />
            Skills
          </button>
        </li>
        <li className="text-yellow-400 hover:underline cursor-pointer md:text-right">
          <button
            onClick={() => setActiveSection("contact")}
            className="inline-block text-xl mr-1 transition duration-300 transform hover:animate-runningColors hover:animate-runningColors"
            style={{ color: 'yellow' }}
          >
            <FaEnvelope />
            Contact Me
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default NavBar;
